import {post} from "@/axios/request";

export const getHallList = (page, size, data) => {
  return post("/service/api/client/getHallList",
    {
      page,
      size,
      ...data
    }
  )
}

export const getHallInfo = data => {
  return post("/service/api/hallExtend/getHallInfo", data)
}
